// extracted by mini-css-extract-plugin
export default {"focusLink":"focusLink---zbzI7","showOnFocus":"showOnFocus---ubbOX"};